export default "__VITE_ASSET__DknPMzD5__"